/*** 
 *  ！これはソースファイルです！ 
 *   実際にページで読み込むのは
 *   これをwebpackでバンドルしたbundle.jsです
 */

// import '../css/style.scss';  // group-css-media-queriesを通すと上書き順序が崩れるため
                                // SCSSはVScode拡張でコンパイルする
import '@babel/polyfill';
// import Swiper from 'swiper'; // バージョンの都合4系をCDNから直接読み込み
import objectFitImages from 'object-fit-images';
import SmoothScroll from 'smooth-scroll';
import LazyLoad from 'vanilla-lazyload';

var breakpoint = 768;
var breakpoint_sp = 600;

var gnav;
var btnMenu;
var smoothScr = null;

var domain = 'www.komorebi-camp.jp';


window.addEventListener('DOMContentLoaded', function() {

    // 画像の遅延読み込み
    const lazyLoadInstance = new LazyLoad({
        elements_selector: ".lazy"
    });
    lazyLoadInstance.loadAll();


    // トップページスライダー
    const topSlider = new Swiper('.top-cover__slider-container', {
        loop: true,
        speed: 2000,
        autoplay: {delay: 3500},
        effect: 'fade'
    });

    // ページ内スライダー
    const innerSlider = new Swiper('.inner-slider', {
        loop: true,
        speed: 700,
        navigation: {
            prevEl: '.inner-slider__nav.prev',
            nextEl: '.inner-slider__nav.next',
        }
    });

    // メニューボタン
    btnMenu = document.querySelector('.btn-gnav');
    gnav = document.querySelector('.gnav-wrapper');
    gnav.style.display = 'none';
    
    btnMenu.addEventListener('click', toggleMenu);

    const toggleMenu = function(e) {
        if (btnMenu.classList.contains('open') && gnav.classList.contains('open')) {
            gnav.classList.remove('open');
            btnMenu.classList.remove('open');
            btnMenu.classList.add('close');
            gnav.classList.add('close');
            setTimeout(function() {
                if (!btnMenu.classList.contains('open')) {
                    gnav.style.display = 'none';
                }
            }, 200);
        }
        else {
            gnav.style.display = 'flex';
            setTimeout(function() {
                gnav.classList.remove('close');
                btnMenu.classList.remove('close');
                btnMenu.classList.add('open');
                gnav.classList.add('open');
            }, 50);
        }
    }
    btnMenu.addEventListener('click', toggleMenu);


    // リサイズ制御
    var resizeTimer = null;
    var prev = window.innerWidth;
    window.addEventListener('resize', function() {
        if (prev > breakpoint && window.innerWidth < breakpoint) {

        }
        prev = window.innerWidth;
    });
    prev = window.innerWidth;


    // スムーススクロール
    smoothScr  =  smoothScr  ? smoothScr  : new SmoothScroll('a:not(.css-slider__anchor)[href*="#"]', {
        easing: "easeInOutQuad",
        speed: 800,
	    speedAsDuration: true,
        updateURL: false,	
        offset: function (anchor, toggle) {
            if (window.innerWidth > breakpoint) {
                return 0;
            }
            else {
                return 0;
            }
        }
    });

    // object-fitのIE11対応
    objectFitImages();


    // vh初期化
    if ( window.innerWidth <= breakpoint ) {
        // 最初に、ビューポートの高さを取得し、0.01を掛けて1%の値を算出して、vh単位の値を取得
        var vh = window.innerHeight * 0.01;
        // カスタム変数--vhの値をドキュメントのルートに設定
        document.documentElement.style.setProperty('--vh', vh + 'px');
    }

    
    // スクロールで表示制御
    const observer = new IntersectionObserver( function(changes) {
        Array.prototype.forEach.call(changes, function(c) {
            // if (c.intersectionRatio > 0.2) {
            if (c.intersectionRatio > 0.2) {
                c.target.classList.add('active');
                observer.unobserve(c.target);
            }
        });
      }, {threshold: [0.2]});
    //   }, {threshold: [0.2]});
    var targets = document.querySelectorAll('.slide-ltr,.slide-rtl,.slide-mask-ltr,.slide-mask-rtl,.fade-up');
    Array.prototype.forEach.call(targets, function(t) {
        t.classList.remove('active');
        observer.observe(t);  
    })
});